import { useParams } from "react-router-dom";
import AppBar from "../../../components/atoms/appbar";
import { vw } from "../../../lib/utils/responsiveUtils";
import { useGetResveCancelDetail } from "../../../@apis/hooks/useResve";
import { useQuery } from "@tanstack/react-query";
import { formatKoDayDate } from "../../../lib/utils/dateUtils";
import { staticURL } from "../../../lib/utils/imageUtils";

export default function ReservationHistoryCancel() {
  const { id } = useParams();

  const { data: resveCancelDetailResponse } = useQuery({
    ...useGetResveCancelDetail(id!),
  });
  const resveCancelDetailInfo = resveCancelDetailResponse?.data?.myResveCancelInfo;
  
  if (!resveCancelDetailInfo) return <p>로딩중...</p>;
  
  const { golfParkName, golfCourseName, golfParkImageUrl, cancelDate, cancelTime, baseDate, startTime, amt, payMemberNum, refundAmt, cardName, cardNo } = resveCancelDetailInfo;
  
  const formattedCardNo = (cardNo ?? "").replace(/(.{4})(?=.)/g, "$1-");
  const formattedCancelTime = cancelTime ? cancelTime.slice(0, 2) + ":" + cancelTime.slice(2, 4) : "";

  return (
    <div className="flex flex-col min-h-screen"> 
      <AppBar backButton />

      <div className="px-[15px] mb-[15px]">
        <div className="rounded-[15px] bg-[#f5f5f5] p-[20px] flex items-center" style={{ height: vw(95) }}>
          <div className="flex flex-col justify-center gap-[14px]">
            <p className="font-bold text-[#222]" style={{ fontSize: vw(20) }}>
              예약 취소
            </p>
            <p className="font-[500] text-[#888]" style={{ fontSize: vw(12) }}>
              {formatKoDayDate(cancelDate)} {formattedCancelTime}
            </p>
          </div>
        </div>

        <div className="mt-[15px]">
          {/* 날짜 영역 */}
          <div className="rounded-[15px] bg-[#f5f5f5] p-[20px] flex items-center" style={{ height: vw(60) }}>
            <p className="font-bold text-[#ccc] text-center line-through" style={{ fontSize: vw(16) }}>
              {formatKoDayDate(baseDate)} {startTime}
            </p>
          </div>

          <div className="mx-auto" style={{ width: vw(315), height: "1px", backgroundImage: "repeating-linear-gradient(to right,#e6e6e6 0 3px,transparent 6px 5px)", borderRadius: "2px", }} />

          {/* 내용 영역 */}
          <div className="rounded-[15px] bg-[#f5f5f5] p-[20px] flex items-center" style={{ height: vw(124) }}>
            <div className="flex items-center gap-[19px]">
              <img
                className="rounded-[10px] object-cover bg-white"
                style={{ width: vw(83), height: vw(83) }}
                src={
                  golfParkImageUrl
                    ? staticURL(golfParkImageUrl) 
                    : "/images/img-login-logo.webp"  
                }
                alt="골프장 이미지"
              />
              <div className="flex flex-col justify-center">
                <p className="text-[#222] font-bold" style={{ fontSize: vw(20) }}>
                  {golfParkName}
                </p>
                <div className="mt-[18px] pl-[15px] border-l-[2px] border-[#e6e6e6]">
                  <p
                    className="text-[14px] text-[#333] font-[500]"
                    style={{ fontSize: vw(14) }}
                  >
                    {golfCourseName}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-[15px]">
          <div className="mt-[15px] rounded-[15px] bg-[#f5f5f5] p-[20px] flex items-center justify-between" style={{ height: vw(60) }}>
            <p className="font-bold text-[#222]" style={{ fontSize: vw(16) }}>
              라운드 비용
            </p>
            <p className="font-bold text-[#222]" style={{ fontSize: vw(20) }}>
              {payMemberNum}인 {amt.toLocaleString()}원
            </p>
          </div>

          <div className="mx-auto" style={{ width: vw(315), height: "1px", backgroundImage: "repeating-linear-gradient(to right,#e6e6e6 0 3px,transparent 6px 5px)", borderRadius: "2px", }} />

          <div className="rounded-[15px] bg-[#f5f5f5] p-[20px] flex flex-col justify-center" style={{ height: vw(106) }}>
            <div className="flex items-center justify-between">
              <p className="text-[#222] font-bold" style={{ fontSize: vw(16) }}>결제 정보</p>
              <p className="text-[#ccc] font-bold line-through" style={{ fontSize: vw(20) }}>{amt.toLocaleString()}원</p>
            </div>

            <div className="mt-[15px] pl-[15px] border-l-[2px] border-[#e6e6e6]">
              <div className="flex justify-between">
                <p className="text-[#888] font-[500]" style={{ fontSize: vw(14) }}>결제 수단</p>
                <p className="text-[#222] font-[500]" style={{ fontSize: vw(14) }}>{cardName && `${cardName}카드 ${formattedCardNo}`}</p>
              </div>
              <div className="flex justify-between mt-[6px]">
                <p className="text-[#888] font-[500]" style={{ fontSize: vw(14) }}>결제 금액</p>
                <p className="text-[#222] font-[500]" style={{ fontSize: vw(14) }}>{amt.toLocaleString()}원</p>
              </div>
            </div>
          </div>

          <div className="mx-auto" style={{ width: vw(315), height: "1px", backgroundImage: "repeating-linear-gradient(to right,#e6e6e6 0 3px,transparent 6px 5px)", borderRadius: "2px", }} />
          
          <div className="rounded-[15px] bg-[#f5f5f5] p-[20px] flex flex-col justify-center" style={{ height: vw(194) }}>
            <div className="flex items-center justify-between">
              <p className="text-[#222] font-bold" style={{ fontSize: vw(16) }}>환불 정보</p>
              <p className="text-[#e5002b] font-bold" style={{ fontSize: vw(20) }}>{refundAmt.toLocaleString()}원</p>
            </div>

            <div className="mt-[15px] pl-[15px] border-l-[2px] border-[#e6e6e6]">
              <div className="flex justify-between">
                <p className="text-[#888] font-[500]" style={{ fontSize: vw(14) }}>결제 수단</p>
                <p className="text-[#222] font-[500]" style={{ fontSize: vw(14) }}>{cardName && `${cardName}카드 ${formattedCardNo}`}</p>
              </div>
              <div className="flex justify-between mt-[6px]">
                <p className="text-[#888] font-[500]" style={{ fontSize: vw(14) }}>결제 금액</p>
                <p className="text-[#222] font-[500]" style={{ fontSize: vw(14) }}>{amt.toLocaleString()}원</p>
              </div>
              <div className="flex justify-between mt-[6px]">
                <p className="text-[#888] font-[500]" style={{ fontSize: vw(14) }}>취소 수수료</p>
                <p className="text-[#222] font-[500]" style={{ fontSize: vw(14) }}>{(amt - refundAmt).toLocaleString()}원</p>
              </div>
            </div>
            <div className="mt-[14px] bg-[#fff] rounded-[15px] text-[#888] font-[500] flex items-center justify-center" style={{ height: vw(50), fontSize: vw(12) }}>
              환불은 영업일 기준 3일~10일정도 소요될 수 있습니다.
            </div>
          </div>
        </div>
        <div className="mt-[25px] flex flex-col">
          <p className="font-bold" style={{ fontSize: vw(16) }}>취소 사유</p>
          <div className="mt-[19px] p-[20px] bg-[#f5f5f5] rounded-[10px] text-[#888] flex items-center" style={{ height: vw(50), fontSize: vw(14) }}>
            개인 사정으로 인한 취소 
          </div>
        </div>
      </div>
    </div>
  );
}